import styled from "styled-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const PagePreviewWrapper = styled(FlexRow)`
    z-index: 2;
    justify-content: space-between;
    width: 763px;
    height: 265px;
    padding-bottom: 100px;
    @media only screen and (max-width: 1400px) {
        width: 650px;
        height: 200px;
    }
`;
